import { Link, useLocation } from 'react-router-dom';
import * as C from './styles.js';
import { FaXmark } from "react-icons/fa6";
import { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import { personAge } from './components/person-age.js';
import { FiMaximize, FiMinimize } from "react-icons/fi";
import Photos from './components/photos/index.js';
import About from './components/about/index.js';
import Movies from './components/movies/index.js';
import Load from '../../components/load/index.js';
import Filters from './components/movies/filters/index.js';

export default function Person({ linkBack, person_id, all_movies, movies_person }) {

    const [ person, setPerson ] = useState();
    const [ personExternalIds, setPersonExternalIds ] = useState();
  
    const [ maximized, setMaximized ] = useState(false);
    const [ showFilters, setShowFilters ] = useState(false);

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const label = queryParams.get('label');

    const [filters, setFilters] = useState({});
    
    useEffect(() => {
        const fetchData = async () => {
            try {
                const personResponse = await fetch(
                    `https://api.themoviedb.org/3/person/${person_id}?api_key=${process.env.REACT_APP_TMDB_KEY}&language=pt-BR`
                );
                const personData = await personResponse.json();
                setPerson(personData);

                const externalIdsResponse = await fetch(
                    `https://api.themoviedb.org/3/person/${person_id}/external_ids?api_key=${process.env.REACT_APP_TMDB_KEY}`
                );
                const externalIdsData = await externalIdsResponse.json();
                setPersonExternalIds(externalIdsData);

                console.log(personData);
            } catch (error) {
                console.error("Erro ao buscar dados da API:", error);
            }
        };

        fetchData();
        console.log(movies_person)
    }, [person_id, movies_person]);
    
    return (
        <C.Container>
            <C.Content full_page={maximized}>
                {person ? 
                    <>
                        <header className='header-person'>
                            <Link to={linkBack}><FaXmark size={20} color='#fff'/></Link>
                            <button onClick={()=>setMaximized(!maximized)}>{maximized ? <FiMinimize size={20} color='#fff'/> : <FiMaximize size={20} color='#fff'/>}</button>
                        </header>
                        <C.PersonContainer>

                            {person?.name &&
                                <section className="person">
                                    <section className="section-info">
                                        <img className="image" loading="lazy" src={person && (person?.profile_path ? `https://image.tmdb.org/t/p/w200${person?.profile_path}` : 'https://dflix.netlify.app/imagens/img-avatar.png')} alt={person?.name} onError={({ currentTarget }) => {currentTarget.onerror = null; currentTarget.src="https://dflix.netlify.app/imagens/img-avatar.png";}}/>
                                        <div className="div-about">
                                            <section className="name">
                                                <h1>{person?.name}</h1>
                                                {person.birthday && !person.deathday &&
                                                    <span className="years-old">{personAge(person)} Anos</span>
                                                }
                                                {personExternalIds &&
                                                    <div className="div-external-ids">
                                                        <Swiper
                                                            slidesPerView={'auto'}
                                                            spaceBetween={10}
                                                            freeMode={false}
                                                            pagination={{
                                                                clickable: true,
                                                            }}
                                                            className="swiper-external-ids"
                                                        >
                                                            
                                                            {personExternalIds.instagram_id &&
                                                                <SwiperSlide>
                                                                    <a target="_blank" href={`https://www.instagram.com/${personExternalIds.instagram_id}`}><i className="fa-brands fa-instagram"></i> <span>Instagram</span> </a>
                                                                </SwiperSlide>
                                                            }
                                                            {personExternalIds.twitter_id &&
                                                                <SwiperSlide>
                                                                    <a target="_blank" href={`https://twitter.com/${personExternalIds.twitter_id}`}><i class="fa-brands fa-x-twitter"></i> <span>Twitter</span> </a>
                                                                </SwiperSlide>
                                                            }
                                                            {personExternalIds.facebook_id &&
                                                                <SwiperSlide id="facebook-external-id">
                                                                    <a target="_blank" href={`https://www.facebook.com/${personExternalIds.facebook_id}`}><i className="fa-brands fa-facebook"></i> <span>Facebook</span> </a>
                                                                </SwiperSlide>
                                                            }
                                                        </Swiper>
                                                    </div>
                                                }
                                            </section>
                                        </div>
                                    </section>
                                    <nav className="nav-person">
                                        <Swiper
                                            slidesPerView={'auto'}
                                            spaceBetween={10}
                                            freeMode={false}
                                            pagination={{
                                            clickable: true,
                                            }}
                                        >
                                            <SwiperSlide>
                                                <section className="section-categoria-person-exibir">
                                                    <label id={!label && 'label-categoria-person-exibir'}>
                                                        <Link id={!label && 'link-exibir'} to={`?pessoa=${person_id}`}>Participações</Link>
                                                    </label>
                                                </section>
                                            </SwiperSlide>
                                            <SwiperSlide>
                                                <section className="section-categoria-person-exibir">
                                                    <label id={label == 'fotos' && 'label-categoria-person-exibir'}>
                                                        <Link id={label == 'fotos' && 'link-exibir'} to={`?pessoa=${person_id}&label=fotos`}>Fotos</Link>
                                                    </label>
                                                </section>
                                            </SwiperSlide>
                                            <SwiperSlide>
                                                <section className="section-categoria-person-exibir">
                                                    <label id={label == 'sobre' && 'label-categoria-person-exibir'}>
                                                        <Link id={label == 'sobre' && 'link-exibir'} to={`?pessoa=${person_id}&label=sobre`}>Sobre</Link>
                                                    </label>
                                                </section>
                                            </SwiperSlide>
                                        </Swiper>
                                    </nav>
                                </section>
                            }
                            {!label &&
                                <Movies movies_person={movies_person} person_id={person_id} all_movies={all_movies} maximized={maximized} setShowFilters={setShowFilters} filters={filters} setFilters={setFilters}/>
                            }
                            {label == 'fotos' &&
                                <Photos person_id={person_id} maximized={maximized}/>
                            }
                            {label == 'sobre' &&
                                <About person_id={person_id} person_details={person} externalIds={personExternalIds} maximized={maximized}/>
                            }
                        </C.PersonContainer>
                    </>
                    :
                    <Load align_center={true}/>
                }
            </C.Content>
            <Filters showFilters={!label && showFilters} setShowFilters={setShowFilters} filters={filters} setFilters={setFilters}/>
        </C.Container>
    )
}